/**
 * The Alt key's name on this platform: Option on a Mac. Used wherever the Preview tells people
 * that Alt makes the pointer the text tool (Issues #3312, #3338).
 */
export function altKeyName(nav: Pick<Navigator, 'platform' | 'userAgent'> | undefined = globalThis.navigator): string {
  const platform = (nav as (Navigator & { userAgentData?: { platform?: string } }) | undefined)?.userAgentData
    ?.platform;
  const isMac = /mac/i.test(platform || nav?.platform || nav?.userAgent || '');
  return isMac ? 'Option' : 'Alt';
}
